import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[sdClickOutside]',
  standalone: true,
})
export class SdvorClickOutsideDirective {
  @Output() sdClickOutside = new EventEmitter<void>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:mousedown', ['$event.target'])
  // @ts-expect-error no-unused-variable
  private onClick(target: HTMLElement): void {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.sdClickOutside.emit();
    }
  }
}
